var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !!_vm.value
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px", persistent: "" },
              on: {
                input: function ($event) {
                  return _vm.$emit("input", $event)
                },
              },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Delete Account"),
                  ]),
                  _c("v-card-text", { staticClass: "pb-1" }, [
                    _c("div", { staticClass: "text-container" }, [
                      _c("span", { staticClass: "title-text" }, [
                        _vm._v(" Are you sure you want to "),
                        _c("b", [_vm._v("DELETE")]),
                        _vm._v(" the account "),
                        _c("b", [_vm._v(_vm._s(_vm.account.Name))]),
                      ]),
                    ]),
                  ]),
                  _c("v-card-text", { staticClass: "pb-1" }, [
                    _c("span", { staticClass: "title-text" }, [
                      _vm._v("This action will delete the user(s) below:"),
                    ]),
                  ]),
                  _c("v-card-text", { staticClass: "pb-1" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.userEmails, function (userEmail) {
                        return _c("li", { key: userEmail }, [
                          _vm._v(_vm._s(userEmail)),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "v-form",
                    { staticClass: "ml-3 mr-3" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          label: "To confirm it, enter delete",
                          rules: [() => !!_vm.confirmationText || "Required"],
                        },
                        model: {
                          value: _vm.confirmationText,
                          callback: function ($$v) {
                            _vm.confirmationText = $$v
                          },
                          expression: "confirmationText",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-container",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c("v-icon", { attrs: { size: "30", color: "red" } }, [
                        _vm._v("mdi-alert"),
                      ]),
                      _c("span", { staticClass: "subtitle-text" }, [
                        _vm._v(
                          "This action will delete all user(s) listed above and it can not be undone."
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("input", null)
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            disabled: _vm.confirmationText != "delete",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteAccount(_vm.account)
                            },
                          },
                        },
                        [_vm._v("DELETE")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { opacity: 0.5, value: _vm.loading, "z-index": "300" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "42" },
          }),
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "primary", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackBar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackBar,
            callback: function ($$v) {
              _vm.snackBar = $$v
            },
            expression: "snackBar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackBarText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }